// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__34ya3","additionalNotes":"styles_additionalNotes__wVaNW","loginButton":"styles_loginButton__3MheT"};